import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-graph-item-row',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule],
  template: `
    <div class="flex items-center justify-between h-[48px] border-b border-[var(--border)]">
      <span class="font-semibold text-[13px] leading-4 text-[var(--text-color)]">{{ name() }}</span>
      <div class="flex items-center gap-(--gap-tight)">
        <button
          type="button"
          (click)="configure.emit()"
          class="flex items-center justify-center w-6 h-6 cursor-pointer rounded-(--radius-md) hover:bg-[var(--surface-hover)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--p-primary-ui)] focus-visible:ring-offset-1"
          [attr.aria-label]="'graphs.measureChip.configureAria' | transloco: { name: name() }">
          <i class="pi pi-cog text-base text-(color:--text-secondary)" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          (click)="remove.emit()"
          class="flex items-center justify-center w-6 h-6 cursor-pointer rounded-(--radius-md) hover:bg-[var(--surface-hover)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-1"
          [attr.aria-label]="'graphs.measureChip.removeAria' | transloco: { name: name() }">
          <i class="pi pi-times text-base text-red-600" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  `,
})
export class GraphItemRowComponent {
  readonly name = input.required<string>();
  readonly configure = output<void>();
  readonly remove = output<void>();
}
